<template>
  <Layout>
    <div class="is-size-7 p-md">
      <div class="has-text-centered" style="margin:auto;max-width:600px;">
        <p><img src="static/kyfbanner.png" class="image" style="margin:auto;"></p>
        <p class="is-size-5 has-text-primary">KeepYouFit - най-добрият портал за фитнес и хранене!</p>
        <div class="m-md">
          <span class="button is-primary is-size-3">Плати с мобилния оператор</span>
        </div>
        <p class="is-size-7 m-t-lg m-b-lg">
          Цената е 6.01 лв. за месец
        </p>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Home',
  components: {
    Layout
  },
  data () {
    return {
      isMsisdn: true,
      msisdn: '0',
      carrier: '23001'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangKyf/BG/LPOtp.vue